import { Know } from 'interfaces/Know'
import theme from 'stories/utils/theme'
import styled from 'styled-components'
import { Body1 } from '../Typography/Text'
import FlashcardIcon from 'assets/app/sidebar/flashcard_white.svg'

const FlashcardInfo = styled.div<{ isSmall?: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 15px;

    p {
        width: ${({ isSmall }) => (isSmall ? 100 : 175)}px;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
    }
`

const FlashcardBadge = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    background-color: ${theme.colors.deepSeaBlue};
    padding: 0 4px;
    width: fit-content;
    top: 12.5px;
    left: 12.5px;
    svg {
        width: 22.5px !important;
        height: 22.5px !important;
    }
`

interface Props {
    know: Know
    isSmall?: boolean
}

const FlashcardInfoPreview = ({ know, isSmall }: Props) => {
    return (
        <FlashcardInfo isSmall={isSmall}>
            {!isSmall ? (
                <FlashcardBadge>
                    <FlashcardIcon />
                </FlashcardBadge>
            ) : null}
            <Body1 fontFamily="var(--font-inter)" textAlign="center" fontWeight={400} color={theme.colors.white}>
                {know.title}
            </Body1>
        </FlashcardInfo>
    )
}

export default FlashcardInfoPreview
